import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../components/PageTemplate/PageTemplate';
import BasicText from '../components/BasicText/BasicText';
import ActionButton from '../components/ActionButton/ActionButton';
import TriggerSettingsQueryContainer from './TriggerSettingsQueryContainer';
import CompleteModalContainer from './CompleteModalContainer';
import { ThermostatsActions } from '../../../store/actionCreators';
import { setSettingTriggers } from '../../../lib/functions';
import { withRouter } from 'react-router-dom';
import Store from '../../../store';
import { getOS } from '../../../lib/functions';

class SettingViewContainer extends Component {
  state = {
    shouldShowCompleteModal: false
  };

  handleDisconnectDevice = () => {
    const thermostatsState = Store.getState() && Store.getState().thermostats;

    if (thermostatsState != null && thermostatsState.awairQueryParams != null) {
      const targetId = thermostatsState.targetId;
      const deviceUuid = thermostatsState.awairQueryParams.deviceUuid;
      const deviceType = thermostatsState.awairQueryParams.deviceType;
      const action = thermostatsState.action;

      ThermostatsActions.setLoading();

      setSettingTriggers(deviceUuid, deviceType, action, targetId, []);
    }
  };

  openPlayStore = () => {
    const { isEcobee } = this.props;
    if (isEcobee) {
      window.android && window.android.navigateToEcobeePlayStore();
    } else {
      window.android && window.android.navigateToSensiPlayStore();
    }
  };

  openAppStore = () => {
    const { isEcobee } = this.props;
    if (isEcobee) {
      window.location.replace('ecobee://');
    } else {
      window.location.replace('sensi://');
    }
  };

  openThermostatsApp = () => {
    const { openPlayStore, openAppStore } = this;
    // Won't work on android if os of core store is used
    const OS = getOS(window.navigator.userAgent);

    if (OS === 'Android') {
      openPlayStore();
    } else if (OS === 'iOS') {
      openAppStore();
    }
  };

  render() {
    const { contents, accessToken, deviceUuid, targetId, isEcobee } = this.props;
    const { handleDisconnectDevice } = this;
    const { shouldShowCompleteModal } = this.state;
    if (!accessToken) {
      return null;
    }

    const deviceType = deviceUuid.split('_')[0];

    return (
      <PageTemplate>
        <CompleteModalContainer isClosed={!shouldShowCompleteModal} />
        <BasicText text={contents.settingGuideText1[deviceType]} />
        <TriggerSettingsQueryContainer deviceUuid={deviceUuid} targetId={targetId} isEcobee={isEcobee} />
        <BasicText text={contents.settingGuideText2} />
        <ActionButton text={contents.moveAppBtnText} onClick={this.openThermostatsApp} />
        <ActionButton negative={true} text={contents.disconnectBtnText} onClick={handleDisconnectDevice} />
      </PageTemplate>
    );
  }
}

export default withRouter(
  connect(
    ({ thermostats }) => ({
      accessToken: thermostats.awairQueryParams.accessToken,
      deviceUuid: thermostats.awairQueryParams.deviceUuid,
      targetId: thermostats.targetId,
      isValueInitialized: thermostats.isValueInitialized,
      action: thermostats.action
    }),
    () => ({})
  )(SettingViewContainer)
);



// WEBPACK FOOTER //
// ./src/app/thermostats/containers/SettingViewContainer.js